(function () {
  'use strict';
  var root = document.getElementById('rsp');
  if (!root) return;

  function nextMonth(d) {
    var y = d.getFullYear(), m = d.getMonth() + 1, day = d.getDate();
    var last = new Date(y, m + 1, 0).getDate();
    return new Date(y, m, Math.min(day, last));
  }
  function fmt(d) {
    var appEl = document.getElementById('rex-studio');
    var loc = (appEl && appEl.getAttribute('data-locale')) || document.documentElement.lang || 'en-US';
    var opts = { year: 'numeric', month: 'long', day: 'numeric' };
    var list = [loc, loc.split('-')[0], 'en-US'];
    for (var i = 0; i < list.length; i++) {
      try { var s = d.toLocaleDateString(list[i], opts); if (s) return s.replace(/\.$/, ''); } catch (e) {}
    }
    return d.toDateString();
  }
  var when = fmt(nextMonth(new Date()));

  var spans = root.querySelectorAll('[data-rs-date]');
  for (var i = 0; i < spans.length; i++) spans[i].textContent = when;

  var copyEl = document.getElementById('rs-copy');
  if (copyEl) {
    try {
      var copy = JSON.parse(copyEl.textContent);
      var walk = function (o) {
        if (typeof o === 'string') return o.split('{date}').join(when);
        if (Array.isArray(o)) { for (var j = 0; j < o.length; j++) o[j] = walk(o[j]); return o; }
        if (o && typeof o === 'object') { for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) o[k] = walk(o[k]); return o; }
        return o;
      };
      copy = walk(copy);
      copy.date = when;
      copyEl.textContent = JSON.stringify(copy);
    } catch (e) {}
  }

  var app = document.getElementById('rex-studio');
  var fb = document.getElementById('rsp-fallback');
  if (app && fb) {
    var check = function () { if (!app.firstElementChild) fb.hidden = false; };
    var t = setTimeout(check, 7000);
    try {
      new MutationObserver(function () {
        if (app.firstElementChild) { clearTimeout(t); fb.hidden = true; }
      }).observe(app, { childList: true });
    } catch (e) {}
    var rl = fb.querySelector('[data-rsp-reload]');
    if (rl) rl.addEventListener('click', function () { location.reload(); });
  }

  var bar = document.getElementById('rsp-bar');
  var offer = document.getElementById('rsp-offer');
  if (bar && offer) {
    var fin = document.getElementById('rsp-final');
    var btns = bar.querySelectorAll('button');
    var on = false, queued = false;
    var update = function () {
      queued = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var o = offer.getBoundingClientRect();
      var past = o.bottom < 0;
      var finalIn = false;
      if (fin) { var f = fin.getBoundingClientRect(); finalIn = f.top < vh && f.bottom > 0; }
      var want = past && !finalIn;
      if (want !== on) {
        on = want;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        for (var b = 0; b < btns.length; b++) btns[b].tabIndex = on ? 0 : -1;
      }
    };
    var ask = function () { if (!queued) { queued = true; window.requestAnimationFrame(update); } };
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    update();
  }
})();
